import React, { useState } from 'react'
import { Save } from 'lucide-react'
import api from 'api/api'
import UpvalueGlyph from 'components/votes/UpvalueGlyph'
import { REACTION_OPTIONS } from 'components/votes/reactions'
import styles from 'components/modals/reactionUpvalueIntro.module.scss'

interface ReactionUpvalueIntroProps {
    closeModal: () => void
}

const DEMO_AMOUNTS = ['10K', '100K', '1M']
const DEMO_REACTIONS = REACTION_OPTIONS.slice(0, 4)

export default function ReactionUpvalueIntro({ closeModal }: ReactionUpvalueIntroProps) {
    const [dontShowAgain, setDontShowAgain] = useState(true)

    const handleGotIt = () => {
        try {
            if (dontShowAgain && gon?.currentUser) {
                gon.currentUser.options = {
                    ...(gon.currentUser.options || {}),
                    has_seen_reaction_upvalue_intro: true,
                }
                api.updateUserOptions({ has_seen_reaction_upvalue_intro: true })?.catch(
                    (error: unknown) => {
                        if (gon?.currentUser?.options) {
                            gon.currentUser.options.has_seen_reaction_upvalue_intro = false
                        }
                        console.error('Failed to persist reaction upvalue intro flag', error)
                    },
                )
            }
        } catch (error) {
            console.error('Failed to persist reaction upvalue intro flag', error)
        }
        closeModal()
    }

    return (
        <div className={styles.comp} data-testid="reaction-upvalue-intro-modal">
            <p className={styles.text}>
                In the Reactions menu you can choose the amount to send with this reaction:
            </p>
            <div className={styles.amountDemo} aria-hidden>
                {DEMO_AMOUNTS.map((amount, index) => (
                    <div
                        key={amount}
                        className={index === 0 ? styles.amountPillSelected : styles.amountPill}
                    >
                        {amount}
                    </div>
                ))}
            </div>

            <p className={styles.text}>Save the default upvalue amount:</p>
            <div className={styles.saveDemo} aria-hidden>
                <Save size={16} aria-hidden />
                <span>Save</span>
            </div>

            <p className={styles.text}>Send an emoji reaction with your upvalue:</p>
            <div className={styles.reactionDemo} aria-hidden>
                {DEMO_REACTIONS.map(option => (
                    <div key={option.emoji} className={styles.reactionPill}>
                        <UpvalueGlyph emoji={option.emoji} className={styles.reactionEmoji} />
                    </div>
                ))}
            </div>

            <div className={styles.footer}>
                <label className={styles.dontShow}>
                    <input
                        type="checkbox"
                        data-testid="reaction-upvalue-intro-dont-show-checkbox"
                        checked={dontShowAgain}
                        onChange={ev => setDontShowAgain(ev.target.checked)}
                    />
                    <span>Don&apos;t show this again</span>
                </label>
                <button
                    type="button"
                    className={styles.gotItButton}
                    data-testid="reaction-upvalue-intro-got-it-button"
                    onClick={handleGotIt}
                >
                    Got it
                </button>
            </div>
        </div>
    )
}
